import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathControlWorkflowPlaybooks(playbookId=null) {
  if (playbookId) {
      return `control/workflow-playbooks/${playbookId}`;
  } else {
      return `control/workflow-playbooks`;
  }
}

export function createControlWorkflowPlaybooks(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlWorkflowPlaybooks(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlWorkflowPlaybooks(successCallback, errorCallback, data, playbookId) {
  patchAuth({
    "path": pathControlWorkflowPlaybooks(playbookId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlWorkflowPlaybooks(successCallback, errorCallback, playbookId) {
  deleteAuth({
    "path": pathControlWorkflowPlaybooks(playbookId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderControlWorkflowPlaybooks(successCallback, errorCallback, data, playbookId) {
  postAuth({
    "path": `control/workflow-playbooks/${playbookId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewControlManageWorkflowPlaybooks(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-workflow-playbooks`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewControlWorkflowPlaybookEditor(playbookId=null) {
  if (playbookId) {
      return `view/control/workflow-playbook-editor/${playbookId}`;
  } else {
      return `view/control/workflow-playbook-editor`;
  }
}

export function getViewControlWorkflowPlaybookEditor(successCallback, errorCallback, playbookId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewControlWorkflowPlaybookEditor(playbookId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


